"use strict";
// Removed these polyfills, babel should do this
// // polyfill window.location.origin
// if (!window.location.origin) {
//     window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
// }
// // polyfill window.origin
// if (!window.origin) {
//     window.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
// }
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeIframe = exports.notifyLoadFailed = exports.notifySaveFailed = exports.notifyError = exports.notifySuccess = exports.reloadContainer = exports.clearInputsIn = exports.copyStringToClipboard = exports.CopyToClipboard = void 0;
const $ = require("jquery");
const translations_1 = require("./translations");
function CopyToClipboard(containerId) {
    console.log("copied from container \"" + containerId + "\"");
    try {
        if (!document.queryCommandSupported("copy") || !document.queryCommandEnabled("copy")) {
            navigator.clipboard.writeText($("#" + containerId).text());
            return;
        }
    }
    catch (e) {
        console.warn(e);
    }
    // @ts-ignore
    if (document.selection) {
        // @ts-ignore
        const range = document.body.createTextRange();
        range.moveToElementText(document.getElementById(containerId));
        range.select().createTextRange();
        document.execCommand("copy");
    }
    else if (window.getSelection) {
        const range = document.createRange();
        range.selectNode(document.getElementById(containerId));
        window.getSelection().addRange(range);
        document.execCommand("copy");
    }
}
exports.CopyToClipboard = CopyToClipboard;
function copyStringToClipboard(str) {
    // Create new element
    const el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
}
exports.copyStringToClipboard = copyStringToClipboard;
function clearInputsIn(id) {
    const elements = document.getElementsByTagName("input");
    for (let i = 0; i < elements.length; i++) {
        if (elements[i].type === "text") {
            elements[i].value = "";
        }
        if (elements[i].type === "checkbox") {
            elements[i].checked = false;
        }
    }
}
exports.clearInputsIn = clearInputsIn;
function reloadContainer(containerId, successCallback) {
    const url = window.location.pathname;
    // console.log("Called reloadContainer with container", {
    //     container: containerId,
    //     url: url,
    // });
    $.ajax({
        url: url,
        type: "GET",
        success: function (data) {
            // console.groupCollapsed("Fetched Content");
            // console.log({fetchedData: data});
            const fetched = $(data);
            const replacement = $(containerId, fetched);
            // console.log({extractedContainer: replacement});
            $(containerId).html(replacement[0].outerHTML);
            // console.log("Successfully replaced container!");
            // console.log({replacedContent: $(containerId).outerHTML});
            // console.groupEnd();
            if (successCallback != null) {
                successCallback(data);
            }
        }
    });
}
exports.reloadContainer = reloadContainer;
function notifySuccess(message = translations_1.translate("notification.success")) {
    const options = {
        title: "<span style='font-weight: bold;'>Erfolgreich" + (message ? ": </span>" : "</span>"),
        message: message ? message : ""
    };
    const settings = {
        placement: {
            align: "center"
        },
        delay: 10000,
        type: "success",
        animate: {
            enter: 'animate__animated animate__fadeInDown',
            exit: 'animate__animated animate__fadeOutUp'
        },
        template: '<div style="z-index: 10000;" data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert">' +
            '<img data-notify="icon" class="img-circle pull-left">' +
            '<span data-notify="title">{1}</span>' +
            '<span data-notify="message">{2}</span>' +
            '</div>'
    };
    $.notify(options, settings);
}
exports.notifySuccess = notifySuccess;
function notifyError(message = translations_1.translate("notification.error")) {
    const options = {
        title: "<span style='font-weight: bold;'>" + translations_1.translate("notification.error") + " " + (message ? ": </span>" : "</span>"),
        message: message ? message : ""
    };
    const settings = {
        placement: {
            align: "center"
        },
        delay: 10000,
        type: "danger",
        animate: {
            enter: 'animate__animated animate__fadeInDown',
            exit: 'animate__animated animate__fadeOutUp'
        },
        z_index: 100000,
        template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
            '<img data-notify="icon" class="img-circle pull-left">' +
            '<span data-notify="title">{1}</span>' +
            '<span data-notify="message">{2}</span>' +
            '</div>'
    };
    $.notify(options, settings);
}
exports.notifyError = notifyError;
function notifySaveFailed() {
    notifyError(translations_1.translate("notification.save-failed"));
}
exports.notifySaveFailed = notifySaveFailed;
function notifyLoadFailed() {
    notifyError(translations_1.translate("notification.load-failed"));
}
exports.notifyLoadFailed = notifyLoadFailed;
function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.outerHeight + 'px';
}
exports.resizeIframe = resizeIframe;
